/**
 * InvoiceStatusService
 * Service for InvoiceStatus entity operations
 * Route: api/invoicestatus
 * Controller: InvoiceStatusController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * InvoiceStatusService
 * Handles invoice status CRUD operations
 * Maps to /api/invoicestatus endpoint
 */
export class InvoiceStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? InvoiceStatusService.DEFAULT_SERVICE_PATH,
            basePath: InvoiceStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
InvoiceStatusService.DEFAULT_SERVICE_PATH = 'procurements';
InvoiceStatusService.BASE_PATH = 'api/invoicestatus';
//# sourceMappingURL=InvoiceStatusService.js.map